/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, size: NonNullable<unknown> }} Shopping_PacksInputs */

const en_shopping_packs = /** @type {(inputs: Shopping_PacksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} × ${i?.size}`)
};

const de_shopping_packs = /** @type {(inputs: Shopping_PacksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} × ${i?.size}`)
};

/**
* | output |
* | --- |
* | "{count} × {size}" |
*
* @param {Shopping_PacksInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_packs = /** @type {((inputs: Shopping_PacksInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_PacksInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_packs(inputs)
	return en_shopping_packs(inputs)
});